import { Component, Input, OnInit } from '@angular/core';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';
import { ClientPropertiesObject } from 'src/app/models/tasks/tasks-properties/client-properties/client-properties-object.model';

@Component({
  selector: 'app-client-properties',
  templateUrl: './client-properties.component.html',
  styleUrls: ['./client-properties.component.css']
})
export class ClientPropertiesComponent implements OnInit {

  clientProperties: ClientPropertiesObject;
  @Input() taskDetails: TaskDetailsObject;

  constructor() {

  }

  ngOnInit() {
    this.clientProperties = this.taskDetails.getProperties().getClientProperties();
  }

}
